import { Injectable } from '@angular/core';
import { map, switchMap } from 'rxjs/operators';
import { ArticleAdapter } from '../adapters/article.adapter';
import { ArticleApiService } from '@core/api/services/article-api.service';
import { of } from 'rxjs';
import { ManualArticleApiService } from '@core/api/services/manual-article-api.service';

@Injectable({
  providedIn: 'root'
})
export class ArticleService {

  constructor(
    private articleApiService:ArticleApiService,
    private manualArticleApiService:ManualArticleApiService,
    private articleAdapter:ArticleAdapter,
  ) { }


  getArticle(id: string){
     return this.articleApiService.get(id).pipe(map((x) => (this.articleAdapter.adapt(x))));
  }
  getManualArticle(id: string){
     return this.manualArticleApiService.get(id).pipe(map((x) => (this.articleAdapter.adaptFromManualArticle(x))));
  }

  getManualArticleBySlug(manualId:string,slug:string){
    return this.manualArticleApiService.getBySlug(manualId,slug).pipe(map(x => this.articleAdapter.adaptFromManualArticle(x)))
  }

}